<template>
  <div id="registrants">
    <form
      name="registrantsSearchForm"
      @submit.prevent="searchRegistrations">
      <!-- Registrants Search Text -->
      <b-form-input
        class="flex-fill"
        type="text"
        ref="searchRegistrations"
        placeholder="Enter Registrant search text"
        v-model="searchParams.search">
      </b-form-input>
      <!-- / Registrants Search Text -->

      <!-- Registrants Table -->
      <b-table
        striped
        hover
        stacked="lg"
        small
        show-empty
        sort-by="full_name"
        :items="registrations"
        :fields="fields"
        :empty-text="`No Registrants to show.${!searchParams.search ? ' Please enter search text.' : ''}`">
        <!-- Registrant Actions -->
        <template
          slot="actions"
          slot-scope="{ item }">
          <b-dropdown
            variant="link"
            boundary="window">
            <!-- Hamburger -->
            <template slot="button-content">
              <font-awesome-icon icon="bars"></font-awesome-icon>
            </template>
            <!-- / Hamburger -->

            <!-- Options -->
            <b-dropdown-item
              @click="goToOrder(item.registration_session_uuid)">
              Order Details
            </b-dropdown-item>

            <b-dropdown-item
              @click="goToRegistration(item.event_id, item.id)">
              Registration Details
            </b-dropdown-item>

            <b-dropdown-item
              @click="resendConfirmationEmail(item.registration_session_uuid)">
              Resend Confirmation Email
            </b-dropdown-item>
            <!-- / Options -->
          </b-dropdown>
        </template>
        <!-- / Registrant Actions -->
      </b-table>
      <!-- / Registrants Table -->

      <!-- Search Registrants Button -->
      <b-button
        class="corner-button shadow"
        type="submit"
        variant="primary"
        :disabled="submitting">
        <font-awesome-icon icon="search"></font-awesome-icon> Search
      </b-button>
      <!-- / Search Registrants Button -->
    </form>
  </div>
</template>

<script>
import _ from 'lodash';
import DataSvc from '../services/data';
import EventBus from '../services/event-bus';
import AppMixin from '../services/app-mixin';

export default {
  name: 'registrants',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      submitting: false,
      searchParams: {},
      registrations: [],
      fields: [
        {
          key: 'actions',
          label: '',
          class: 'action-column text-center',
        },
        {
          key: 'registrant.full_name',
          label: 'Name',
        },
        {
          key: 'registrant.email',
          label: 'Email',
        },
        {
          key: 'registrant.primary_phone',
          label: 'Phone',
        },
      ],
    };
  },
  methods: {
    searchRegistrations() {
      const search = _.extend({
        organization_id: this.loggedInUser.actingOrg.id,
        season_id: this.loggedInUser.actingSeason.id,
      }, this.searchParams);

      this.showGlobalLoader('Searching registrants...');
      this.submitting = true;

      return DataSvc.getRegistrations(search)
        .then((registrations) => {
          this.registrations = _.filter(registrations, 'registered');
        })
        .finally(() => {
          this.hideGlobalLoader();
          this.submitting = false;
        });
    },
  },
  created() {
    EventBus.$on('acting-season-changed', this.searchRegistrations);
    this.showGlobalLoader('Loading seasons...');
    this.initPromise.finally(this.hideGlobalLoader);
  },
  destroyed() {
    EventBus.$off('acting-season-changed', this.searchRegistrations);
  },
};
</script>

<style lang="scss"></style>
